import { FC, useEffect, useState } from "react";
import { useAppSelector } from "toolkit/hooks";
import BodyRow from "./BodyRow";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import styles from "./TableBody.module.sass";
import {userAPI} from "libs/apiClient/User";

const TableBody: FC<{ outline: (id: string, isMain: boolean) => string }> = ({ outline }) => {
	const { codes, loading } = useAppSelector((state) => state.codes);

	const [ruleEdit, setRuleEdit] = useState(true);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["dictionary.okved.edit"]).then(({ data }) => {
			setRuleEdit(!!data.length);
		});
	}, []);

	return (
		<div data-comment-false={true} className={styles.tableBody}>
			{loading ? (
				<div className={styles.boxIcon}>
					<LoadingIcon className={styles.loaderIcon} />
				</div>
			) : (
				codes.map((code) => <BodyRow key={code.code} ruleEdit={ruleEdit} outline={outline} row={code} isMain={true} />)
			)}
		</div>
	);
};

export default TableBody;
